<template>
  <div class="carousels">
    <VueSlickCarousel v-bind="settings" :responsive=responsive>


      <template>
        <div class="box" v-for="(item , index) in setcoins" :key="state.type">
          <div class="coinsName">
            <div class="coin">


              <img :src="require('../../assets/coins/'+$coin2Snake[item.sourceCoinSymbol]+'.svg')" alt="">
              <div class="name-coin">
                <span>{{ $coinLabel[item.sourceCoinSymbol] }}</span>
                <small>{{ $coinsUnit[item.sourceCoinSymbol.toUpperCase()] }}</small>
              </div>
            </div>
            <div class="last-price">
              <span class="number"
                    :class="{'red':item.price24hrChangePercent < 0 , 'green':item.price24hrChangePercent >= 0}">{{
                 
                //  parseFloat(item.price24hrChangePercent).toPrecision(3) 
                 
                 $toPrecision(item.price24hrChangePercent,3)
                 
           

                 
                 }}%



               </span>
              <small>24h</small>
            </div>
          </div>
          <div class="price">{{ $toLocal(item.price, $decimal['TOMAN']) + ' ' + 'تومان' }}</div>
          <div class="chart">


            <!--      <apex-chart v-if="item.price24hrChangePercent>=0" height="60"  type="area" :options="chartOptions" :series="[{-->
            <!--                    data:item.lastWeekData-->
            <!--                  }]"></apex-chart>-->
            <!--      <apex-chart v-if="item.price24hrChangePercent<0" height="60"  type="area" :options="chartOptionsNeg" :series="[{-->
            <!--                    data:item.lastWeekData-->
            <!--                  }]"></apex-chart>-->


            <TrendChart

                :datasets="[
    {
      data: [10, 50, 20, 100, 40, 60, 80],
      smooth: true,
      fill: true,
      className:'curveBlue'
    }
  ]"
                :grid="{
     verticalLines: true,
     horizontalLines: true
  }"
                :min="0">

            </TrendChart>


            <TrendChart
                v-if="item.lastChange < 0"
                :datasets="[
    {
      data: [10, 50, 20, 100, 40, 60, 80],
      smooth: true,
      fill: true,
       className:'curveRed'
    }
  ]"
                :grid="{
     verticalLines: true,
     horizontalLines: true
  }"
                :min="0">

            </TrendChart>


          </div>

        </div>
      </template>
    </VueSlickCarousel>

  </div>

</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: "the-popular-coin",
  // props:{
  //   coins: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
// props:['coins'],
  computed: {
    setcoins() {
      let coins = '';
      coins = this.$store.state.usd
      // console.log(coins)
      return coins
    }

  },

  components: {VueSlickCarousel},
  watch: {
    'setcoins'() {
      let coins = '';
      coins = this.$store.state.usd
      // console.log(coins)
      this.state.loading = false
    },
  },
  data() {
    return {

      chartOptions: {
        chart: {
          height: '30',
          sparkline: {
            enabled: true,
          }
        },
        stroke: {
          width: 2,
          // curve: 'smooth'
        },
        tooltip: {
          enabled: false
        },


        colors: ['transparent'],

        fill: {
          colors: ['rgba(24, 160, 251, 1)'],
          type: 'gradient',
          gradient: {
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100]
          }
        },


      },
      chartOptionsNeg: {
        chart: {
          height: '30',
          sparkline: {
            enabled: true,
          }
        },
        stroke: {
          width: 2,
          // curve: 'smooth'
        },
        tooltip: {
          enabled: false
        },


        colors: ['transparent'],

        fill: {
          colors: ['rgba(184, 76, 76, 1)'],
          type: 'gradient',
          gradient: {
            opacityFrom: 1,
            opacityTo: 0,
            stops: [0, 100]
          }
        },


      },
      responsive: [
        {
          "breakpoint": 1200,
          "settings": {
            "slidesToShow": 3,
            "slidesToScroll": 1,
            "infinite": true,
            "dots": false
          }
        },
        {
          "breakpoint": 992,
          "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 1,
            "infinite": true,
            "dots": false,
            "arrow":false
          }
        },
        {
          "breakpoint": 600,
          "settings": {
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "initialSlide": 2,
            "arrows":false
          }
        },
        {
          "breakpoint": 480,
          "settings": {
            "slidesToShow": 1,
            "slidesToScroll": 1,
            "initialSlide": 1,
            // "centerMode": true,
            "arrows": false
          }
        }
      ],

      settings: {
        rtl: true,
        arrows: true,
        autoplay: true,
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplaySpeed: 1800,
        useCSS: true,
        // centerMode:true,
      }
    }
  },
  mounted() {
    // console.table(  this.coins)
    this.state.loading = true;
  }
}
</script>

<style lang="scss" scoped>
.carousels{
  text-align: center;
}

.box {
  max-width: 250px;
  height: 194px;
  background: #0B1426;
  box-shadow: 0 0 14px -1px rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  direction: rtl;
  cursor: pointer;
  transition: box-shadow 0.3s, fill 0.3s;

  &:hover {
    box-shadow: 0 0 24px -1px rgba(255, 255, 255, 0.06) !important;
  }

  .coinsName {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px;

    .coin {
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: revert;
      flex-direction: row;
      gap: 8px;

      span {
        color: rgba(251, 251, 253, 1);
      }

      small {
        color: rgba(215, 200, 200, 1);
      }

      img {
        width: 40px;
        height: 40px;
      }

      .name-coin {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
    }

    .last-price {
      flex-grow: 1;
      display: flex;
      align-items: end;
      flex-direction: column;

      small {
        color: rgba(215, 200, 200, 1);
      }
    }
  }

  .price {
    color: #FBFBFD;
    text-align: center;
    font-weight: bold;
  }

  .box:hover .price {
    font-size: 17px;
  }

  .chart {
    margin: 25px auto;
    width: 80%;
    height: 52px;
    display: flex;
    justify-content: center;

    .svg {
      position: absolute;
      width: 0 !important;
      height: 0 !important;
    }
  }
}


</style>

<style>
.slick-slider {
  display: flex !important;
  justify-content: center !important;
}

.slick-list {
  width: 80% !important;
  padding: 20px 0 !important;
}

.slick-prev {
  left: 100px !important;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  background-image: url("../../assets/Home/perv.png");
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  outline: none !important;
}

.slick-next {
  right: 100px !important;
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  background-image: url("../../assets/Home/next.png");
  background-size: inherit;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  outline: none !important;
}

.slick-prev::before {
  color: transparent !important;
}


.slick-next::before {
  color: transparent !important;
}


.curveBlue .fill {
  fill: url('#btcFill1');
  transition: fill 5s linear;
}

.curveBlue .stroke {
  stroke: #8bd1ff !important;
  stroke-width: 2 !important;
  transition: fill 5s linear;
}

.curveRed .fill {
  fill: url('#btcFill2');
  transition: fill 5s linear;
}

/*.box:hover .curveRed .fill{*/
/*  fill: url('#btcFillHover1');*/
/*}*/

/*.box:hover .curveBlue .fill{*/
/*  fill: url('#btcFillHover2');*/
/*}*/


.curveRed .stroke {
  stroke: rgba(250, 17, 185, 0) !important;
  stroke-width: 2 !important;
  transition: fill 5s linear;
}

</style>